var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg016Cloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3699 10.09C18.6823 6.56076 15.5955 4.01005 11.9999 4C9.16232 3.98834 6.56447 5.5897 5.29994 8.13C2.62176 8.66498 0.741819 11.0841 0.884835 13.8115C1.02785 16.5388 3.1505 18.7481 5.86994 19C6.07966 19.0152 6.29021 19.0152 6.49994 19H18.4999C20.8062 18.9871 22.7294 17.2328 22.9535 14.9374C23.1776 12.642 21.6301 10.5488 19.3699 10.09ZM18.4999 17H6.49994H6.10994C4.17694 17 2.60994 15.433 2.60994 13.5C2.60994 11.567 4.17694 10 6.10994 10C6.47438 9.96225 6.78899 9.7282 6.92994 9.39C7.89049 7.02901 10.3497 5.63968 12.8677 6.0355C15.3857 6.43132 17.3001 8.50817 17.4899 11.05C17.5268 11.5748 17.9639 11.9813 18.4899 11.98C19.8706 11.98 20.9899 13.0993 20.9899 14.48C20.9899 15.8607 19.8706 16.98 18.4899 16.98L18.4999 17Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg016Cloud);
export default __webpack_public_path__ + "static/media/016-cloud.40adf412f1090a9d48821d3a9c0fea0e.svg";
export { ForwardRef as ReactComponent };